import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=19214f08&scoped=true&"
import script from "./Pricing.vue?vue&type=script&lang=ts&"
export * from "./Pricing.vue?vue&type=script&lang=ts&"
import style0 from "./Pricing.vue?vue&type=style&index=0&id=19214f08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19214f08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
